import React from 'react';
import TodoList from './components/TodoList';

export default function App() {
	return <TodoList />;
}
